<template>
  <v-container>
    <PageHeadingText :title="gameData?.title" />
    <div
      class="d-flex flex-column align-center justify-center my-10 text-center"
      v-if="isNotsupported"
    >
      <device-not-supported classes="pb-10"></device-not-supported>
      <get-started
        customBtnText="error.btnText"
        :customBtnLink="$globals.links.homeUrl"
      ></get-started>
    </div>
    <template v-else>
      <gameDetails
        v-if="$api.tenant.default.monsooqMent"
        :structure="structure"
      ></gameDetails>
      <mentGameDetails v-else :structure="structure"></mentGameDetails>
    </template>
  </v-container>
</template>
<script lang="ts" setup>
import { bindTabName } from '@/api/utils';
const { $api, $globals } = useNuxtApp();
import PageHeadingText from '~/components/shared/PageHeadingText.vue';
const route = useRoute();
const mentGameDetails = defineAsyncComponent(
  () => import('~/components/game/mentGameDetails.vue'),
);
const gameDetails = defineAsyncComponent(
  () => import('@/components/game/gameDetails.vue'),
);

const { data, error } = await useAsyncData(async () => {
  let structure;
  structure = await $api.endPoints.getStructure(`pages_games_details`, {
    id: route.params.id,
    omitCache: true,
  });

  await $api.endPoints.loadMissing(structure);
  const gameData = structure?.[0].data;
  let isNotsupported = false;
  if (gameData.errorCode) {
    structure = await $api.endPoints.getStructure(`pages_games_details`, {
      id: route.params.id,
      deviceId: -1,
    });
    let gameError = structure[0]?.data?.errorCode;
    if (gameError) {
    } else {
      isNotsupported = true;
    }
  }
  return { structure, isNotsupported };
});
if (error?.value) {
  throw createError({ statusCode: 404, message: 'Not Found' });
}
let { structure, isNotsupported } = data?.value;
const scripts = $api.tenant?.default?.scripts || [];
const gameData = structure?.[0].data;

const pagescripts = scripts
  ?.filter((e) => !e.default && e.pages.includes('game-details'))
  .map((e) => e.script);
useHead({
  title: bindTabName({
    title: gameData?.title,
    brand: gameData?.developerName,
    vertical: $globals.tabNameSeo.gamesVertical,
    prefix: $globals.tabNameSeo.gamesPrefix,
  }),
  meta: [
    {
      hid: 'og:title',
      name: 'og:title',
      content: gameData?.title,
    },
    {
      hid: 'og:image',
      itemprop: 'image',
      name: 'og:image',
      content: $api.placebo.placebo(gameData?.imageUrl),
    },
    {
      hid: 'twitter:title',
      name: 'twitter:title',
      content: gameData?.title,
    },
    {
      hid: 'twitter:image',
      name: 'twitter:image',
      content: $api.placebo.placebo(gameData?.imageUrl),
    },
  ],
  link: [
    {
      rel: 'manifest',
      href: `/manifest.json?gameId=${route.params.id}`,
      crossorigin: 'use-credentials',
      id: 'dynamic-manifest',
    },
  ],
  script: pagescripts,
});
</script>
<style lang="scss" scoped></style>
